import {
  Button,
  FormGroup,
  Input,
  Label,
  Margin,
  Size,
  Spinner,
  Text,
  Title,
} from '@drawbotics/react-drylus';
import { useForm } from '@drawbotics/use-form';
import { useAppContext } from '@tokamakjs/react';
import { Fragment } from 'react';
import { z } from 'zod';

import { ResetPasswordController } from '~/routes/reset-password';
import { AppContext } from '~/types';
import { createTranslate, translate as t } from '~/utils';

const tt = createTranslate('routes.reset_password.request_reset_sidebar');

export function RequestReset(props: { controller: ResetPasswordController }) {
  const appContext = useAppContext<AppContext>();

  const schema = z.object({
    email: z.string().min(1, t('errors.field_empty')).email(t('errors.invalid_email')),
  });

  const form = useForm(schema, { defaultValues: { email: '' } });

  return (
    <Fragment>
      <Title>{tt('title')}</Title>
      <Margin size={{ top: Size.SMALL }}>
        {props.controller.resetRequestSent ? (
          <Text>{tt('success')}</Text>
        ) : (
          <Fragment>
            <FormGroup
              label={<Label>{tt('your_email')}</Label>}
              input={
                <Input
                  placeholder={tt('email_placeholder')}
                  name="email"
                  value={form.get}
                  onChange={form.set}
                  error={form.getError}
                />
              }
            />
            <Margin size={{ top: Size.DEFAULT }}>
              <Button
                disabled={props.controller.isSendingResetRequest}
                trailing={
                  props.controller.isSendingResetRequest ? (
                    <Spinner size={Size.SMALL} inversed />
                  ) : null
                }
                color={appContext.color}
                size={Size.LARGE}
                onClick={(e) => {
                  e.preventDefault();

                  const validationResult = form.validateAll();

                  if (validationResult.data) {
                    props.controller.sendResetRequest(validationResult.data);
                  }
                }}>
                {tt('submit')}
              </Button>
            </Margin>
          </Fragment>
        )}
      </Margin>
    </Fragment>
  );
}
